import { deepCopy } from "@perxis-auto/shared/lib/lib/copy";
import { instanceOfReference, instanceOfNumberRange, instanceOfIsoDateRange, instanceOfPrimitive } from "@perxis-auto/shared/lib/lib/instanceOf";
import { ConstructorWidgetEnum } from "../../../../../shared/types/constructor/widget.js";
const createFilterValuesItem = (allRawFilterValuesItem, availableRawFilterValuesItem, filterValuesChoice, filterGridItems) => {
  var _a, _b, _c, _d;
  const filterValuesItem = deepCopy(allRawFilterValuesItem);
  for (const [filterKey, filterValues] of Object.entries(allRawFilterValuesItem.data)) {
    if (!filterValues.length) {
      continue;
    }
    const filterGridItem = filterGridItems.find((item) => item.key === filterKey);
    if (!filterGridItem) {
      continue;
    }
    if (instanceOfReference(filterValues[0])) {
      const filterReferenceValues = [...filterValues];
      const availableFilterReferenceValues = ((_a = availableRawFilterValuesItem.data) == null ? void 0 : _a[filterKey]) || [];
      const existingFilterItemIds = new Set(availableFilterReferenceValues.map((filter) => filter.id));
      filterValuesItem.data[filterKey] = filterReferenceValues.reduce(
        (acc, filterItemValue) => {
          const selectedFilterReferenceValues = filterValuesChoice == null ? void 0 : filterValuesChoice[filterKey];
          const isSelectedFilterItemValue = Array.isArray(selectedFilterReferenceValues) ? selectedFilterReferenceValues.includes(filterItemValue.id) : filterItemValue.id === selectedFilterReferenceValues;
          const isExistFilterItemValue = existingFilterItemIds.has(filterItemValue.id);
          return [
            ...acc,
            {
              ...filterItemValue,
              available: isSelectedFilterItemValue || isExistFilterItemValue
            }
          ];
        },
        []
      );
      continue;
    }
    if ([ConstructorWidgetEnum.FilterSlider, ConstructorWidgetEnum.FilterRangeSlider].includes(filterGridItem.type) && instanceOfNumberRange(filterValues)) {
      const availableFilterRangeValues = ((_b = availableRawFilterValuesItem.data) == null ? void 0 : _b[filterKey]) || filterValues;
      filterValuesItem.data[filterKey] = {
        min: filterValues[0],
        max: filterValues[1],
        value: availableFilterRangeValues
      };
      continue;
    }
    if ([ConstructorWidgetEnum.FilterSlider, ConstructorWidgetEnum.FilterRangeSlider].includes(filterGridItem.type) && instanceOfIsoDateRange(filterValues)) {
      const availableFilterRangeValues = ((_c = availableRawFilterValuesItem.data) == null ? void 0 : _c[filterKey]) || filterValues;
      const getIsoYear = (isoDate) => {
        return Number(isoDate.split("-")[0]);
      };
      filterValuesItem.data[filterKey] = {
        min: getIsoYear(filterValues[0]),
        max: getIsoYear(filterValues[1]),
        value: [getIsoYear(availableFilterRangeValues[0]), getIsoYear(availableFilterRangeValues[1])]
      };
      continue;
    }
    if (instanceOfPrimitive(filterValues[0])) {
      const filterPrimitiveValues = [...filterValues];
      const availableFilterPrimitiveValues = ((_d = availableRawFilterValuesItem.data) == null ? void 0 : _d[filterKey]) || [];
      const existingFilterPrimitiveValues = new Set(availableFilterPrimitiveValues.map((filter) => filter));
      filterValuesItem.data[filterKey] = filterPrimitiveValues.reduce(
        (acc, filterPrimitiveValue) => {
          const selectedFilterPrimitiveValues = filterValuesChoice == null ? void 0 : filterValuesChoice[filterKey];
          const isSelectedFilterPrimitiveValue = Array.isArray(selectedFilterPrimitiveValues) ? selectedFilterPrimitiveValues.includes(filterPrimitiveValue) : filterPrimitiveValue === selectedFilterPrimitiveValues;
          const isExistFilterPrimitiveValue = existingFilterPrimitiveValues.has(filterPrimitiveValue);
          return [
            ...acc,
            {
              value: filterPrimitiveValue,
              available: isSelectedFilterPrimitiveValue || isExistFilterPrimitiveValue
            }
          ];
        },
        []
      );
      continue;
    }
  }
  return filterValuesItem;
};
export {
  createFilterValuesItem
};
